import Equipment from "./Equipment";

export default Equipment;
export { Equipment };
